module.exports = __webpack_public_path__ + "static/nav-previous.88ec36a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav-previous.jpg
// module id = 542
// module chunks = 168707334958949